import { Document } from '@roc/feature-types';
import { Button, StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import BankStatement from './bankStatement';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type BankStatementDialogProps = {
  open?: boolean;
  onClose?: () => void;
  loan: any;
  document: Document;
};

export const BankStatementDialog = observer(
  (props: BankStatementDialogProps) => {
    const { open, onClose, loan, document } = props;
    const taskId = document?.taskId;

    const dialogActions = (
      <>
        <Button
          style={{ marginRight: '8px' }}
          testId="cancel"
          color="default"
          variant="contained"
          onClick={onClose}
        >
          Close
        </Button>
      </>
    );

    return (
      <>
        {taskId ? (
          <CustomTaskDialog
            open={open}
            title="Bank Statement"
            handleClose={onClose}
            dialogActions={dialogActions}
            dialogContent={<BankStatement loan={loan} document={document} />}
            taskId={taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Bank Statement"
            maxWidth="md"
            handleClose={onClose}
            dialogActions={dialogActions}
            dialogContent={<BankStatement loan={loan} document={document} />}
            removeContentBox
          />
        )}
      </>
    );
  }
);

export default BankStatementDialog;
